import React from 'react';

// Plain text with its web links made clickable (e.g. the screen-recording link in a ticket).
// Builds React elements, never HTML, so the text cannot inject markup.
const URL_RE = /(https?:\/\/[^\s<>"']+)/g;

const LinkifiedText = ({ text }) => {
    if (!text) return null;
    return String(text).split(URL_RE).map((part, i) =>
        i % 2 === 1 ? (
            <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
        ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
        )
    );
};

export default LinkifiedText;
